import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import classNames from "classnames";

import sectionsPageStyle from "assets/jss/material-kit-pro-react/views/sectionsPageStyle.js";

import TilesData from "../../assets/json/tiles_data.json";
import TilesDev from "../../assets/json/tiles_data_dev.json";

import { useDispatch, useSelector } from "react-redux";
import { setDashboard } from "redux/ducks/CSPDashboardSlice";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles(sectionsPageStyle);

export default function Layout({ children }) {
	const classes = useStyles();
	const DialogData =
		process.env.REACT_APP_ENV === "development" ? TilesDev : TilesData;
	const dispatch = useDispatch();
	const CSPDashboard = useSelector((state) => state.CSPDashboard);
	const userDetails = useSelector((state) => state.user);
	const navigate = useNavigate();

	const selectDetails = (heading) => {
		const selectedData = DialogData.find((data) => data.Heading === heading);
		const dashboardData = {
			Heading: heading,
			TeamT5Form: false,
			KinetixForm: false,
			CustomerSubscriptionDetails:
				selectedData?.Heading === "Microsoft 365" ? true : false,
			AddCustomerSubscription: false,
			selectedDialogData: selectedData,
			ConfirmOrder: false,
			OrderSummary: false,
		};
		dispatch(setDashboard(dashboardData));
		navigate(`/account`);
	};

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;

		const servicesAssigned = userDetails["services-assigned"];
		if (servicesAssigned) {
			const checkIfServiceAssignedMicrosoft = servicesAssigned?.find(
				(service) => service === "Microsoft 365"
			);

			if (CSPDashboard.Heading === "") {
				const dashboardData = {
					Heading: DialogData[0].Heading,
					TeamT5Form: false,
					KinetixForm: false,
					CustomerSubscriptionDetails:
						checkIfServiceAssignedMicrosoft == "Microsoft 365" ? true : false,
					AddCustomerSubscription: false,
					selectedDialogData: DialogData[0],
					ConfirmOrder: false,
					OrderSummary: false,
				};
				dispatch(setDashboard(dashboardData));
			}
		} else {
			const dashboardData = {
				Heading: DialogData[0].Heading,
				TeamT5Form: false,
				KinetixForm: false,
				CustomerSubscriptionDetails: false,
				AddCustomerSubscription: false,
				selectedDialogData: DialogData[0],
				ConfirmOrder: false,
				OrderSummary: false,
			};
			dispatch(setDashboard(dashboardData));
		}
		return function cleanup() {};
	}, []);

	return (
		<div>
			<Header
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>
			<div className={`${classes.main} `}>
				<div className={classNames(classes.paddingTop)}>
					<div className={classNames("flex")}>
						<div className={classNames(classes.leftSide)}>
							<ul>
								{DialogData.map((data, index) => (
									<li
										key={index}
										onClick={() => selectDetails(data.Heading)}
										className={
											CSPDashboard?.Heading === data.Heading
												? classNames(classes.imgRoundedCircle, classes.selectedTiles)
												: classNames(classes.imgRoundedCircle)
										}>
										<img
											src={data.sideImage}
											alt={data.Heading}
											className={classNames(classes.imgRounded)}
										/>
										<div className={classNames(classes.title)}>{data.title}</div>
									</li>
								))}
							</ul>
						</div>
						<div className={classNames(classes.rightSide)}>{children}</div>
					</div>
				</div>
			</div>
		</div>
	);
}
